
import validator from 'validator';
export default function validate(values) {
    let errors = {};
    if(!values.FirstName){
        errors.FirstName = 'First Name is required'
    }
    if(!values.LastName){
        errors.LastName = 'Last Name is required'
    }
    if(!values.UserName){
        errors.UserName = 'User Name is required'
    } 
    if(!values.EmailID){
        errors.EmailID = 'Email is required'
    } else if(!(validator.isEmail(values.EmailID))){
        errors.EmailID = 'Enter valid email'
    }
    if(!values.ContactNumber){
        errors.ContactNumber = 'Contact Number is required'
    }
    //  else if(!(validator.isMobilePhone(values.ContactNumber, ['en-IN']))) {
    //     errors.ContactNumber = 'Please enter valid mobile number';
    // }
    if(!values.RoleID){
        errors.RoleID = 'Role Number is required'
    }
    return errors;
}